<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="peacohrm-container">
    <div class="peacohrm-vacancy-company-title">
      <oxd-text class="peacohrm-main-title">
        Insharp Technologies
      </oxd-text>
      <img src="https://insharptechnologies.com/wp-content/uploads/2022/07/Insharp-Technologies.png" alt="" height="40">
    </div>
    <vacancy-card
      v-for="vacancy in vacancies?.data"
      :key="vacancy"
      :vacancy-id="vacancy.vacancyId"
      :vacancy-title="vacancy.vacancyTitle"
      :vacancy-description="vacancy.vacancyDescription"
    ></vacancy-card>
    <oxd-loading-spinner v-if="isLoading" class="peacohrm-container-loader" />
    <div v-if="showPaginator" class="peacohrm-bottom-container">
      <oxd-pagination v-model:current="currentPage" :length="pages" />
    </div>
  </div>
  <div class="peacohrm-paper-container">
    <oxd-text tag="p" class="peacohrm-vacancy-list-poweredby">
      {{ $t('recruitment.powered_by') }}
    </oxd-text>
    <img
      :src="defaultPic"
      alt="peacohrm Picture"
      class="peacohrm-container-img"
    />
    <slot name="footer"></slot>
  </div>
</template>

<script>
import VacancyCard from '@/peacohrmRecruitmentPlugin/components/VacancyCard';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@/core/util/composable/usePaginate';
import {OxdSpinner} from '@ohrm/oxd';

export default {
  name: 'VacancyList',
  components: {
    'vacancy-card': VacancyCard,
    'oxd-loading-spinner': OxdSpinner,
  },
  setup() {
    
    const defaultPic = `${window.appGlobal.publicPath}/images/phrm_branding.png`;
    const vacancyDataNormalizer = (data) => {
      return data.map((item) => {
        return {
          vacancyId: item.id,
          vacancyTitle: item.name,
          vacancyDescription: item.description,
        };
      });
    };
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/acquisition/public/vacancies',
    );
    const {showPaginator, currentPage, total, pages, response, isLoading} =
      usePaginate(http, {
        normalizer: vacancyDataNormalizer,
        pageSize: 8,
      });
    return {
      defaultPic,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      vacancies: response,
    };
  },
};
</script>

<style src="./public-job-vacancy.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.peacohrm-vacancy-company-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: 2rem auto;
}
</style>
